export default __webpack_public_path__ + "static/media/DSC01998.5e989d22.jpg";